import { render, staticRenderFns } from "./tuckcomb.vue?vue&type=template&id=48e4a010&scoped=true&"
import script from "./tuckcomb.vue?vue&type=script&lang=js&"
export * from "./tuckcomb.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=48e4a010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e4a010",
  null
  
)

export default component.exports